<template>
<!-- eslint-disable max-len -->
  <div>

    <div id="content-wrap">
      <div v-if="$attrs.vehicleType === 'Commercial'">
        <h1 class="pageTitle" id="title" role="banner">
          Compare Commercial EVs
        </h1>
      </div>
      <div v-else>
        <h1 class="pageTitle mobileTitle" id="title" role="banner">
          Compare EVs
        </h1>
      </div>
      <div style="align-content: center; height: auto; margin: 0 0 20px 0;">
        <span class="subheader" style="font-size: 20px; color: var(--dark-grey); font-weight: 600; float: left; margin-top: 15px;">
          {{totalItems}} results
        </span>
        <div class="buttonContainer" style="float: right;">
          <button class="buttonStyleAccent"
            id="copy-link"
            aria-label="copy link"
            @click="copyLink()">
            <font-awesome-icon icon="fa-solid fa-link" />
            Copy Link
          </button>

          <button :class="state.filterLiked ? 'buttonStyleAccentDark' : 'buttonStyleAccent'"
          @click="state.filterLiked = !state.filterLiked; logMessage('info', 'Compare Liked Cars', state.filterLiked); resetInfiniteScroll()">
            <font-awesome-icon :icon="state.filterLiked
              ? 'fa-solid fa-heart' : 'fa-regular fa-heart'"/>
              Compare Favorites ({{numLiked}})
          </button>
        </div>
      </div>
      <!-- <hr class="headerHR"> -->
      <div class="controlPanelItemListWrapper">
        <!-- Todo: determine how to fix side panel position with scroll... style="position: fixed; top:200px" -->
        <div class="controlPanel" aria-label="control panel" role="form">
          <div class="iconAddonWrapper">
            <img src="../../assets/search.svg" alt="search icon" class="iconAddonLeft">
            <input v-model="state.searchInput" @change="logMessage('info', 'Search', state.searchInput); resetInfiniteScroll()"
              aria-label="search"
              role="search"
              type="text"
              id="searchInput"
              placeholder="Search"
              class="textinput">
          </div>
          <select v-model="state.filterFuelType" @change="logMessage('info', 'Filter Fuel Type', state.filterFuelType); resetInfiniteScroll()"
            aria-label="filter fuel type"
            name="fuel-type"
            id="fuel-type"
            class="round">
            <option value="" selected>Fuel</option>
            <!-- Options are hardcoded to display different human readable names -->
            <option value="BEV"> Battery Electric Vehicle </option>
            <option value="PHEV"> Plug-In Hybrid EV</option>
          </select>
          <select v-model="state.filterMake" @change="logMessage('info', 'Filter Make', state.filterMake); resetInfiniteScroll()"
            aria-label="filter make"
            name="make-model"
            id="make-model"
            class="round">
            <option value="" selected>Make</option>
            <!-- Dynamically compute options from the data. Automatically updates if options are added/removed from data -->
            <option v-for="(val, index) in $parent.$parent.ev_data.filter(car => car.type === this.$attrs.vehicleType).map(
                (item) => item.make
              ).filter(
                (value, index, current_value) => current_value.indexOf(value) === index).sort()" :key="index"> {{val}}
            </option>
          </select>
          <select v-model="state.filterFormFactor" @change="logMessage('info', 'Filter Type', state.filterFormFactor); resetInfiniteScroll()"
            aria-label="filter type"
            name="form-factor"
            id="form-factor"
            class="round">
            <option value="" selected>Type</option>
            <!-- Dynamically compute options from the data. Automatically updates if options are added/removed from data -->
            <option v-for="(val, index) in $parent.$parent.ev_data.filter(car => car.type === this.$attrs.vehicleType).map(
                (item) => item.form_factor
              ).filter(
                (value, index, current_value) => current_value.indexOf(value) === index).sort()" :key="index"> {{val}}
            </option>
          </select>
          <select v-model="state.filterYear" @change="logMessage('info', 'Filter Year', state.filterYear); resetInfiniteScroll()"
            aria-label="filter year"
            name="year"
            id="year"
            class="round">
            <option value="" selected>Year</option>
            <!-- Dynamically compute options from the data. Automatically updates if options are added/removed from data -->
            <option v-for="(val, index) in $parent.$parent.ev_data.filter(car => car.type === this.$attrs.vehicleType).map(
                (item) => item.model_year
              ).filter(
                (value, index, current_value) => current_value.indexOf(value) === index).sort()" :key="index"> {{val}}
            </option>
          </select>
          <!-- TODO initialize min/max values from data instead of hardcoding -->
          <div class="sliderContainer">
            <div>Minimum Range: {{state.filterRange}}</div>
            <input
              v-model="state.filterRange"
              @change="logMessage('info', 'Filter Seats',state.filterRange); resetInfiniteScroll()"
              aria-label="filter seats"
              name="seats"
              id="seats"
              type="range"
              :min="0"
              :max="500"
              class="sliderInput">
          </div>
          <div class="sliderContainer">
            <div>Minimum Seats: {{state.filterSeats}}</div>
            <input
              v-model="state.filterSeats"
              @change="logMessage('info', 'Filter Seats',state.filterSeats); resetInfiniteScroll()"
              aria-label="filter seats"
              name="seats"
              id="seats"
              type="range"
              :min="2"
              :max="8"
              class="sliderInput">
          </div>
          <label class="checkboxContainer" for="liked">
            <input type="checkbox"
              name="liked"
              id="liked"
              @change="state.filterLiked = !state.filterLiked; logMessage('info', 'Filter Liked',state.filterLiked); resetInfiniteScroll()"
              :checked="state.filterLiked"
              aria-label="compare favorites">
            <span class="checkmark"></span>
            <div>Compare Favorites</div>
          </label>
          <hr>
          <select v-model="state.sortKey" @change="logMessage('info', 'Sort By', state.sortKey); resetInfiniteScroll()"
            aria-label="sort by"
            name="sort"
            id="sort"
            class="round">
              <option value='msrp'>Sort By: MSRP</option>
              <!-- Options hardcoded to surface specific keys for filtering in a human readable way -->
              <option value='electric_range' selected>Sort By: Battery Range</option>
              <option value='total_range' selected>Sort By: Total Range</option>
              <option value='miles_per_kwh'>Sort By: Efficiency (miles/kWh)</option>
              <option value='horsepower'>Sort By: Horsepower</option>
              <option value='seats_max'>Sort By: Seats</option>
              <option value='model_year'>Sort: Year</option>
              <option v-if="this.$attrs.vehicleType == 'Commercial'" value='payload'>Sort By: Payload</option>
              <option v-if="this.$attrs.vehicleType == 'Commercial'" value='curb_weight'>Sort By: Curb Weight</option>
              <option v-if="this.$attrs.vehicleType == 'Commercial'" value='gvwr'>Sort By: GVWR</option>
          </select>
          <select v-model="state.sortDirection" @change="logMessage('info', 'Sort Order', state.sortDirection > 0 ? 'Low to High' : 'High to Low'); resetInfiniteScroll()"
            aria-label="toggle sort order">
            <option value="1" selected>Low to High</option>
            <!-- Options are hardcoded to display different human readable names -->
            <option value="-1"> High to Low </option>
          </select>
          <!-- TODO this reset needs to be updated every time state model is changed (or default vals are)
            I could see this leading to issues. TODO refactor so that these defaults only live in one place. -->
          <button class="buttonStyle"
            @click="state = {
                      searchInput: '',
                      sortKey: 'msrp',
                      sortDirection: 1,
                      filterMake: '',
                      filterFormFactor: '',
                      filterSeats: 2,
                      filterRange: 0,
                      filterFuelType: '',
                      filterLiked: false,
                    };
                    resetInfiniteScroll()">
            <font-awesome-icon icon="fa-regular fa-circle-xmark" />
            Reset Filters
          </button>
        </div>

        <div class="itemListWrapper">
          <div id="itemList" class="itemList">
            <span class="loader" v-if="showLoading"></span>
            <div v-if="totalItems == 0 && !showLoading" style="margin: 20px 40px;">
              No EV models were found. Please update the selected filters<span v-if="state.filterLiked">, or deselect the Compare Favorites button</span>.
            </div>

            <div v-for="(car, index) in getFilteredEVData()"
              v-bind:key="index"
              class="itemBlock"
              aria-labelledby="car_name">
              <div>
                <button @click="car.liked = !car.liked; logMessage('info', 'Liked Car', `${car.make} {charger.display_name} (${car.model_year})`)"
                  class="likeButton"
                  aria-label="like button">
                  <font-awesome-icon :icon="car.liked
                    ? 'fa-solid fa-heart' : 'fa-regular fa-heart'"
                    style="height: auto;"/>
                </button>
                <h6>
                  <strong class='right' style="font-size: 100%;" id="car_name">{{car.make}} {{car.model}}</strong>
                  <!-- <div style="display:inline-block; width: 200px; height: 140px;"></div> -->
                </h6>

                <div>
                   <span class="large">{{car.trim}} {{car.form_factor}} ({{car.model_year}})</span>
                </div>
                <span>
                  <!-- specify width/height and max width heights to force lazy load image placeholder size to not distort display -->
                  <!-- Also 100% max width causes image to shrink in proportion with screen size on smaller devices -->
                  <!-- Removed v-lazy optimization due to garbage experience on mobile. Downsides of no lazy load: higher api calls and slower initial page load -->
                  <div class="ev-model-img-container" style="text-align: center; overflow: hidden; height:160px;">
                    <img :src="(car.image_url + '&t=' + Date.now()) || require('../../assets/dalle_generic_commercial_3.png')"
                      :key="car.image_url" width=auto height=250
                      :alt="car.display_name + ' ' + car.model_year" />
                      <!-- style="max-width: 190%; height:auto; max-height: 250px; margin: -50px -100px -40px -100px;" -->
                  </div>
                  <!-- Button routes to Savings Calculator preset to display this vehicle and use it's efficiency -->
                  <!-- <div style="display: flex; justify-content: left; align-items: left;"> -->
                  <div class="buttonContainer" style="justify-content: center;">
                    <button class="buttonStyleDark" style="padding: 0 5px; flex: 1 1 auto; font-size: clamp(14px, 1.3vw, 15px) !important;"
                      @click="$router.push({path: `/${$parent.client_api_path}/savings_calculator`,
                      query: { carIndex: car.index, filterMake: car.make }})">
                      <font-awesome-icon icon="fa-solid fa-calculator" />
                      Calculate Savings
                    </button>
                    <button class="buttonStyle" style="padding: 0 clamp(5px, 0.5vw, 10px); flex: 1 1 auto; font-size: clamp(14px, 1.3vw, 15px) !important;"
                      @click="changeRoute(car.official_website_url)">
                      <font-awesome-icon icon="fa-solid fa-circle-info" />
                      Learn More
                    </button>
                  </div>
                  <div style="display: flex; flex-direction: row; flex-wrap: wrap;">
                    <div class="ev-model-detail">
                      <b>MSRP: </b>
                      <span v-if="car.msrp">{{car.msrp | currencyUSDWhole}}</span>
                      <span v-else>Unavailable</span>
                    </div>

                    <div v-if="$attrs.vehicleType === 'Commercial'">
                      <div class="ev-model-detail">
                        <b>Payload: </b>
                        <span>{{car.payload}} lbs</span>
                      </div>
                      <div class="ev-model-detail">
                        <b>Curb Weight: </b>
                        <span>{{car.curb_weight}} lbs</span>
                      </div>
                      <div class="ev-model-detail">
                        <b>GVWR: </b>
                        <span>{{car.gvwr}} lbs</span>
                      </div>
                    </div>

                    <div class="ev-model-detail">
                      <b>Efficiency: </b>
                      <span>{{ car.miles_per_kwh | numberTwoDecimal}} miles/kWh</span>
                    </div>
                    <div class="ev-model-detail">
                      <b>Battery Range: </b>
                      <span>{{car.electric_range | numberWhole}} miles</span>
                    </div>
                    <div class="ev-model-detail" v-if="car.electric_range !==car.total_range">
                      <b>Total Range: </b>
                      <span>{{car.total_range | numberWhole}} miles</span>
                    </div>
                    <div class="ev-model-detail" v-if="car.electric_range !==car.total_range">
                      <b>Battery Capacity: </b>
                      <span>{{car.battery_capacity}} kWh</span>
                    </div>
                    <div class="ev-model-detail">
                      <b>Seats: </b>
                      <span>{{car.seats_max}}</span>
                    </div>

                    <!-- <b>Horsepower: </b>
                    <span>{{car.horsepower}}</span>
                    <br />

                    <b>Seats: </b>
                    <span>{{car.seats_max}}</span>
                    <br />

                    <b>Vehicle Type: </b>
                    <span>{{car.form_factor}}</span>
                    <br />

                    <b>Plug Types: </b>
                    <span>{{(car.plug_types).join(', ')}}</span>
                    <br /> -->

                    <!-- Boolean logic since we only display CA incentives for Marin County -->
                    <!-- And also only display "Incentives:" if there are incentives to display... -->
                    <!-- There's definitely a more elegant way to do this, which I'll sort out when we have more state specific incentives to deal with. Maybe these should eventually be handled using linked records like the home incentive calculator -->
                  </div>
                </span>
              </div>
              <div class="vehicleIncentiveBox" v-if="car.eligible_for_usa_tax_credit ||
                ($parent.client_api_path == 'marincounty' && (car.eligible_for_ca_hov || car.eligible_for_ca_rebate))">
                <strong>Available Incentives:</strong>
                <ul style="margin: 0">
                  <!-- <a href='https://www.irs.gov/credits-deductions/credits-for-new-clean-vehicles-purchased-in-2023-or-after' target='_blank'> -->
                  <li v-if="car.eligible_for_usa_tax_credit">Federal Tax Credit: {{car.usa_tax_credit_rebate | currencyUSDWhole}}</li>
                  <!-- Only display these two incentives for Marin County. Can expand if we obtain other CA clients. -->
                  <li v-if="car.eligible_for_ca_hov && $parent.client_api_path == 'marincounty'">Eligible for CA HOV</li>
                  <li v-if="car.eligible_for_ca_rebate && $parent.client_api_path == 'marincounty'">Eligible for CA rebate</li>
                  <!-- <li v-if="car.san_joaquin_valley_ev_rebate">San Joaquin Valley EV Rebate: {{car.san_joaquin_valley_ev_rebate | currencyUSDWhole}}</li> -->
                </ul>
              </div>
            </div>
            <div class="itemBlockSpacer"></div>
            <div class="itemBlockSpacer"></div>
            <div class="itemBlockSpacer"></div>
            <div class="itemBlockSpacer"></div>
            <div class="itemBlockSpacer"></div>
          </div>

          <div id="scroll-trigger" style="height: 1px;">
            <!-- <button class="buttonStyle" @click="loadMore()">Load More</button> -->
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
/* eslint-disable no-console */
/* eslint-disable max-len */

export default {
  data() {
    return {
      state: {
        searchInput: '',
        sortKey: '',
        sortDirection: '',
        filterMake: '',
        filterFormFactor: '',
        filterSeats: '',
        filterRange: '',
        filterFuelType: '',
        filterLiked: '',
        filterYear: '',
      },
      default: {
        searchInput: '',
        sortKey: 'msrp',
        sortDirection: 1,
        filterMake: '',
        filterFormFactor: '',
        filterSeats: 2,
        filterRange: 0,
        filterFuelType: '',
        filterLiked: false,
        filterYear: '',
      },
      totalItems: 0,
      minPrice: 0,
      maxPrice: 0,
      numLiked: 0,

      page: 1,
      busy: false,
      displayItems: 0,
      displayingAll: false,
      infiniteScrollId: null,
      infiniteScrollIdPrevious: null,

      showLoading: true,
      isTraversing: false,
    };
  },
  mounted() {
    // console.log('mounted and adding scroll listener', window);
    window.addEventListener('scroll', this.handleScroll.bind(this));
    this.scrollTrigger = document.querySelector('#scroll-trigger');
    if (window) {
      window.scrollTo(0, 0); // { top: 0, behavior: 'instant' });
    }
    this.handleScroll();

    const mutationObserver = new MutationObserver((mutationsList) => {
      Array.from(mutationsList).forEach(() => {
        this.busy = false;
        this.showLoading = false;
      });
    });
    mutationObserver.observe(document.querySelector('#itemList'), { attributes: true, childList: true, subtree: true });

    // Deep watcher monitors all properties inside 'state' and updates URL
    this.$watch('state', () => {
      // console.log('state changed, updating url', this.state);
      this.updateUrlFromState();
    }, { deep: true });
    // handle back especially after pushing state
    window.onpopstate = () => {
      this.updateStateFromRoute();
    };
  },
  // unmounted() {
  //   // console.log('unmounted and removing scroll listener');
  //   // window.removeEventListener('scroll', this.handleScroll());
  // },
  methods: {
    updateUrlFromState() {
      // console.log('updateUrlFromState', this.isTraversing);
      if (this.isTraversing) { return; }
      const path = this.getPathFromState();
      window.history.replaceState({ ...window.history.state }, '', path);
    },
    getPathFromState() {
      // Turns state of filters/sort/search into a query parameterized url and copies to clipboard.
      // State vars are loaded on created(), with the exception of likes which are loaded in App.vue
      const queries = [];
      if (this.state.searchInput) {
        queries.push(`searchInput=${this.state.searchInput}`);
      }
      if (this.state.sortKey) {
        queries.push(`sortKey=${this.state.sortKey}`);
      }
      if (this.state.sortDirection) {
        queries.push(`sortDirection=${this.state.sortDirection}`);
      }
      if (this.state.filterMake) {
        queries.push(`filterMake=${this.state.filterMake}`);
      }
      if (this.state.filterFormFactor) {
        queries.push(`filterFormFactor=${this.state.filterFormFactor}`);
      }
      if (this.state.filterSeats) {
        queries.push(`filterSeats=${this.state.filterSeats}`);
      }
      if (this.state.filterRange) {
        queries.push(`filterRange=${this.state.filterRange}`);
      }
      if (this.state.filterFuelType) {
        queries.push(`filterFuelType=${this.state.filterFuelType}`);
      }
      if (this.state.filterLiked) {
        queries.push(`filterLiked=${this.state.filterLiked}`);
      }
      if (this.state.filterYear) {
        queries.push(`filterYear=${this.state.filterYear}`);
      }
      // Comma separated list of likes for use in query param using filter map
      const liked = this.$parent.$parent.ev_data.filter((car) => car.liked).map((car) => car.index).join(',');
      if (liked) {
        queries.push(`liked=${liked}`);
      }
      const path = `ev_comparison?${queries.join('&')}`;
      // const url = `${[window.location.origin, path].join('/').replaceAll('//', '/')}${queries.join('&')}`;
      return path;
    },
    getUrlFromState() {
      const url = `${[window.location.origin, this.$parent.client_api_path, this.getPathFromState()].join('/').replaceAll('//', '/')}`;
      return url;
    },
    copyLink() {
      const path = this.getUrlFromState();
      navigator.clipboard.writeText(path);
      // this.logMessage('info', 'Copy Link', path);
      return path;
    },
    getFilteredEVData() {
      // Filter
      const filtered = this.$parent.$parent.ev_data.filter((car) => this.passesFilters(car));
      // Update values for banner display of number and min to max
      this.totalItems = filtered.length;
      // console.log('Filtered totalItems', this.totalItems);
      // console.log('ev_data length', this.$parent.$parent.ev_data.filter(() => true).length);
      if (this.$parent.$parent.ev_data.filter(() => true).length > 0 && this.totalItems === 0) {
        this.showLoading = false;
      }
      // https://stackoverflow.com/questions/42413319/get-min-value-from-a-nested-json-object
      this.minPrice = Math.min.apply(null, filtered.map((v) => v.msrp));
      this.maxPrice = Math.max.apply(null, filtered.map((v) => v.msrp));
      this.numLiked = filtered.filter((car) => car.liked).length;
      // Sort based on sort key and direction
      const sorted = filtered.sort((a, b) => this.state.sortDirection * a[this.state.sortKey]
        - this.state.sortDirection * b[this.state.sortKey]);

      // return sorted;
      return sorted.slice(0, this.displayItems);
    },
    passesFilters(car) {
      // console.log(this);
      if (car.type !== this.$attrs.vehicleType) {
        return false;
      }
      // Car string for searching is defined in App.vue data loading
      if (this.state.searchInput
        && !car.carStr.includes(this.state.searchInput.toUpperCase())) {
        return false;
      }
      if (this.state.filterMake && car.make !== this.state.filterMake) {
        return false;
      }
      if (this.state.filterFormFactor && car.form_factor !== this.state.filterFormFactor) {
        return false;
      }
      // Seats and range filters are MINIMUMS not exact match.
      if (this.state.filterSeats && car.seats_max < parseInt(this.state.filterSeats, 10)) {
        return false;
      }
      if (this.state.filterRange && car.total_range < parseInt(this.state.filterRange, 10)) {
        return false;
      }
      if (this.state.filterFuelType && car.fuel !== this.state.filterFuelType) {
        return false;
      }
      if (this.state.filterLiked && !car.liked) {
        return false;
      }
      if (this.state.filterYear && car.model_year !== this.state.filterYear) {
        return false;
      }

      return true;
    },
    handleScroll() {
      // console.log('handleScroll', window.innerHeight, document.documentElement.scrollHeight, window.scrollY, this.scrollTrigger.offsetTop);
      // console.log('handleScroll');
      // console.log(window.innerHeight, document.documentElement.scrollHeight, window.scrollY, window.innerHeight + window.scrollY, this.scrollTrigger.offsetTop);
      // if (!this.scrollTrigger) return;

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
      const windowHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
      // const fullHeight = document.documentElement.scrollHeight || document.body.scrollHeight;

      // const scrollTriggerOffset = this.scrollTrigger.offsetTop;
      const offset = 600; // Trigger load more when the user is within 100px of the scroll trigger element

      if (scrollTop + windowHeight >= this.scrollTrigger.offsetTop - offset) {
        window.setTimeout(this.loadMore.bind(this), 100);
      }
    },
    loadMore() {
      if (this.infiniteScrollId !== this.infiniteScrollIdPrevious) {
        // console.log('state has changed since last load, resetting pagination', this.state, this.stateLoaded);
        // this.stateLoaded = JSON.parse(JSON.stringify(this.state));
        this.page = 1;
        this.displayItems = 0;
        this.displayingAll = false;
        this.busy = false;
      }
      this.infiniteScrollIdPrevious = this.infiniteScrollId;

      if (this.busy || this.displayingAll) return;

      const perPage = 15;
      this.busy = true;
      this.page += 1;
      this.displayItems = perPage * this.page;
      // if (this.displayItems >= this.totalItems) return;
      if (this.totalItems) {
        this.displayingAll = this.displayItems >= this.totalItems;
      }
      // console.log('load more triggered', this.page, this.displayItems, this.totalItems);
      window.setTimeout(() => {
        // this.busy = false;
        this.getFilteredEVData();
        this.handleScroll();
      }, 200);
    },
    resetInfiniteScroll() {
      this.infiniteScrollId = +new Date(); // Reset the infinite scroll by changing its key
      this.showLoading = true;
    },
    updateStateFromRoute() {
      // Load state from url query params OR default
      this.state.searchInput = this.$route.query.searchInput || this.default.searchInput;
      this.state.sortKey = this.$route.query.sortKey || this.default.sortKey;
      this.state.sortDirection = this.$route.query.sortDirection || this.default.sortDirection;
      this.state.filterMake = this.$route.query.filterMake || this.default.filterMake;
      this.state.filterFormFactor = this.$route.query.filterFormFactor
        || this.default.filterFormFactor;
      this.state.filterSeats = this.$route.query.filterSeats || this.default.filterSeats;
      this.state.filterRange = this.$route.query.filterRange || this.default.filterRange;
      this.state.filterFormFactor = this.$route.query.filterFormFactor || this.default.filterFormFactor;
      this.state.filterFuelType = this.$route.query.filterFuelType || this.default.filterFuelType;
      this.state.filterLiked = this.$route.query.filterLiked || this.default.filterLiked;
      this.state.filterYear = this.$route.query.filterYear || this.default.filterYear;
    },
  },
  created() {
    this.updateStateFromRoute();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
